import { useResponsiveValue } from 'braid-design-system';
import React from 'react';

const ShowcaseIcon = () => {
  const responsiveValue = useResponsiveValue();
  return (
    <svg
      style={{ display: 'block' }}
      width={
        responsiveValue({
          mobile: '80px',
          tablet: '96px',
        }) as string
      }
      height={
        responsiveValue({
          mobile: '80px',
          tablet: '96px',
        }) as string
      }
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.125 92.5H16.875C14.1826 92.5 12 90.3174 12 87.625V79.5H103V87.625C103 90.3174 100.817 92.5 98.125 92.5Z"
        fill="#6E56E6"
      />
      <path
        d="M73.75 112H41.25C39.4552 112 38 110.545 38 108.75C38 106.955 39.4552 105.5 41.25 105.5H73.75C75.5448 105.5 77 106.955 77 108.75C77 110.545 75.5448 112 73.75 112Z"
        fill="#6E56E6"
      />
      <path d="M70.5 92.5H44.5V105.5H70.5V92.5Z" fill="#392BA7" />
      <path
        d="M16.8608 27.5H98.1108C100.801 27.5 102.986 29.6844 102.986 32.375V79.5H11.9858V32.375C11.9858 29.6844 14.1702 27.5 16.8608 27.5Z"
        fill="#392BA7"
      />
      <path
        d="M57.5 87.625C58.3975 87.625 59.125 86.8975 59.125 86C59.125 85.1025 58.3975 84.375 57.5 84.375C56.6025 84.375 55.875 85.1025 55.875 86C55.875 86.8975 56.6025 87.625 57.5 87.625Z"
        fill="white"
      />
      <path
        d="M94.9756 35.082H19.9958V52.3515H94.9756V35.082Z"
        fill="#F470BD"
      />
      <path
        d="M35.8916 57.9844H19.9958V72.7882H35.8916V57.9844Z"
        fill="#503DC9"
      />
      <path
        d="M94.9756 57.9844H41.8804V62.4699H94.9756V57.9844Z"
        fill="#503DC9"
      />
      <path
        d="M94.9756 68.3027H41.8804V72.7882H94.9756V68.3027Z"
        fill="#503DC9"
      />
      <path
        d="M112.209 65.9189H92.5054C90.9639 65.9189 89.7144 67.1685 89.7144 68.71V108.99C89.7144 110.532 90.9639 111.781 92.5054 111.781H112.209C113.75 111.781 115 110.532 115 108.99V68.71C115 67.1685 113.75 65.9189 112.209 65.9189Z"
        fill="#392BA7"
      />
      <path
        d="M112.209 63.9189H92.5054C89.8638 63.9189 87.7144 66.0684 87.7144 68.71V108.99C87.7144 111.632 89.8638 113.781 92.5054 113.781H112.209C114.851 113.781 117 111.632 117 108.99V68.71C117 66.0684 114.851 63.9189 112.209 63.9189ZM115 108.99C115 110.529 113.748 111.781 112.209 111.781H92.5054C90.9663 111.781 89.7144 110.529 89.7144 108.99V68.71C89.7144 67.1709 90.9663 65.9189 92.5054 65.9189H112.209C113.748 65.9189 115 67.1709 115 68.71V108.99Z"
        fill="#6E56E6"
      />
      <path
        d="M111.825 70.1475H92.8892V78.5911H111.825V70.1475Z"
        fill="#F470BD"
      />
      <path
        d="M111.825 83.1533H92.8892V87.0001H111.825V83.1533Z"
        fill="#503DC9"
      />
      <path
        d="M111.825 90.6826H92.8892V94.5294H111.825V90.6826Z"
        fill="#503DC9"
      />
      <path
        d="M111.825 98.2119H92.8892V102.059H111.825V98.2119Z"
        fill="#503DC9"
      />
      <path
        d="M102.357 109.89C102.992 109.89 103.506 109.375 103.506 108.741C103.506 108.106 102.992 107.592 102.357 107.592C101.723 107.592 101.208 108.106 101.208 108.741C101.208 109.375 101.723 109.89 102.357 109.89Z"
        fill="white"
      />
    </svg>
  );
};

export default ShowcaseIcon;
